import { observable } from "mobx";
import VehicleRegisterVehiclePropertyChangeDisplayType from "./vehicleRegisterVehiclePropertyChangeDisplayType";

// This entity has been generated, do not change its content, your changes might get lost. You CAN modify the rest of the file.
export default class VehicleRegisterVehicleSynchronizationChangeResponse {
  @observable
  changeType!: VehicleRegisterVehiclePropertyChangeDisplayType;

  /**
   * Original value, only specified for changes other than vehicle parameters or vehicle ID change.
   */
  @observable
  originalValue?: string;

  /**
   * New value, only specified for changes other than vehicle parameters or vehicle ID change.
   */
  @observable
  newValue?: string;
}
